import Signup from "../components/auth/Signup";

export default function SignupPage({ setView }) {
  return <Signup onSignupSuccess={setView} />;
}
